// CalendarDay > ICalendarDay
import { UxGridProps, BlockTypeSelectProps } from '../UxGrid'

export const defaultProps = Object.freeze({
	use24: false,
	locale: 'en-us',
	minBlockLength: 30,
	labelFrequency: 2
})

export type CalendarDayProps<T> = {
	date: Date
} & Pick<
	UxGridProps<T>,
	Exclude<keyof UxGridProps<T>, 'scale' | 'labelConversion' | 'columns' | 'labelFrequency' | 'selectedTypes'>
> &
	BlockTypeSelectProps<T> &
	typeof defaultProps
